
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/OrganizationChart/index.en.md?watch=parent';
    export const demoIndex = {
  ids: ["organizationchart-demo-common","organizationchart-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__OrganizationChart__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/OrganizationChart/index.en.md?type=demo')
};